import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
`

export const Descriptions = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
  margin-bottom: 20px;
`

export const ContentWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${myPalette.blue['500']};
  background: ${myPalette.white.main};
  overflow: hidden;
  padding: 12px;
`

export const ItemWrapper = styled.div`
  border-bottom: 1px solid ${myPalette.blue['500']};
  margin-bottom: 12px;
`

export const ItemTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
`

export const ItemValue = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
  margin: 12px 0;
`

export const GraceNotice = styled.div`
  border-radius: 8px;
  background: ${myPalette.blue['500']};
  padding: 16px;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 1.5;
`
